import { render, staticRenderFns } from "./questionsList.vue?vue&type=template&id=02127b12&scoped=true&"
import script from "./questionsList.vue?vue&type=script&lang=js&"
export * from "./questionsList.vue?vue&type=script&lang=js&"
import style0 from "./questionsList.vue?vue&type=style&index=0&id=02127b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02127b12",
  null
  
)

export default component.exports